import React from 'react';
import { Row, Col, Label } from "reactstrap";

export default class ContainersCard extends React.Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }
    
    render() {
        return (
            <Col xs={12} md={6} lg={4} className={ this.props.ativo ? 'card-containers-col-selecionado' : 'card-containers-col' }>
                <div className="card-containers">
                    <Row className="lado-lado">
                        <Col xs={12} sm={6} className="lado px-2">
                            <Label className="label-tipo">ENTRADA</Label>
                            <Label className="label-data">{ this.props.EntradaData }</Label>
                        </Col>
                        <Col xs={12}  sm={6} className="lado px-2">
                            <Label className="label-tipo">SAÍDA</Label>
                            <Label className="label-data">{ this.props.SaidaData }</Label>
                        </Col>
                        <Col xs={12} className="px-2">
                            <Label className="categoria"><div className="middle">{ this.props.Categoria }</div></Label>
                        </Col>
                    </Row>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/ContainersCard.js